import { Http } from '@services/http/http.service';
import { getUser } from '@store/user/user.selector';
import { useIdleTimer } from 'react-idle-timer';
import { useSelector } from 'react-redux';

type Props = {
  delay?: number;
};

const DEFAULT_CAFE_REFRESH_TOKEN_EXPIRE = 432_000 * 1000;

export const InactivityHandler = ({ delay = DEFAULT_CAFE_REFRESH_TOKEN_EXPIRE }: Props) => {
  const user = useSelector(getUser);

  useIdleTimer({
    timeout: delay,
    throttle: 1000,
    onIdle: () => {
      if (user) Http.getInstance().logout();
    },
    events: [
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
    ],
  });

  return undefined;
};
